import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo, forwardRef } from 'react';
import SliderBase, * as Slider from '@segment/matcha/recipes/TestimonialSlider';
import TestimonialTemplate from '@segment/templates/Testimonial';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import useData from './useData';
import * as views from './TestimonialSlider.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";

var BaseTitle = function BaseTitle(_ref) {
  var tokens = _ref.tokens;
  return _jsxs(views.SliderTitle, {
    variant: "h2",
    tag: "h2",
    children: [_jsx(views.LightText, {
      opacity: tokens.lightTextOpacity,
      children: "Trusted by"
    }), " startups", " ", _jsx(views.LightText, {
      opacity: tokens.lightTextOpacity,
      children: "and the"
    }), " world's largest companies"]
  });
};

var Title = withDesignTokens(BaseTitle, function () {
  return {};
}, {
  light: function light() {
    return {
      lightTextOpacity: 0.7
    };
  },
  dark: function dark() {
    return {
      lightTextOpacity: 0.7
    };
  },
  twilioLight: function twilioLight() {
    return {
      lightTextOpacity: 1
    };
  }
});
var NavigationItemTemplate = /*#__PURE__*/forwardRef(function (props, ref) {
  return _jsx(Slider.NavigationItem, _objectSpread(_objectSpread({
    ref: ref,
    "aria-label": props.logoName
  }, props), {}, {
    children: props.active ? props.logoActive : props.logo
  }));
});

var TestimonialSlider = function TestimonialSlider(_ref2) {
  var _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? useData : _ref2$data,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? true : _ref2$title,
      _ref2$innerStyles = _ref2.innerStyles,
      innerStyles = _ref2$innerStyles === void 0 ? true : _ref2$innerStyles,
      overrides = _ref2.overrides;
  var customerStories = data().map(function (slideProps) {
    return {
      props: slideProps,
      slide: /*#__PURE__*/memo(function (data) {
        return _jsx(TestimonialTemplate, _objectSpread(_objectSpread({
          variant: "extended"
        }, data), {}, {
          overrides: overrides
        }));
      }),
      navItem: NavigationItemTemplate
    };
  });
  return _jsx(views.Wrapper, {
    children: _jsx(SliderBase, {
      delay: 400,
      slides: customerStories,
      children: innerStyles ? _jsxs(views.Inner, {
        children: [title && _jsx(Title, {}), _jsx(Slider.Track, {}), _jsx(Slider.Navigation, {})]
      }) : _jsxs(_Fragment, {
        children: [title && _jsx(Title, {}), _jsx(Slider.Track, {}), _jsx(Slider.Navigation, {})]
      })
    })
  });
};

export default TestimonialSlider;